import React, { useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { 
    Button, 
    Container, 
    Typography, 
    Card, 
    CardContent, 
    Box, 
    Avatar, 
    AppBar, 
    Toolbar,
    CircularProgress,
    IconButton
} from '@mui/material';
import { Google as GoogleIcon, Logout as LogoutIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import Table, { TeamsList } from './MyComponents/Table'
import TournamentSelector from './MyComponents/TournamentSelector'
import { signInWithGooglePopup, auth, db} from "./MyComponents/firebase.utils"
import { doc,  setDoc, getDoc, getDocs, collection } from "firebase/firestore";
import { theme, styles } from './styles';

function App() 
{
    const [ curPage, setCurPage] = useState(-1)
    const [ user, setUser] = useState([])
    const [ userData, setUserData] = useState([])
    const [ users, setUsers] = useState([])
    const [ buttonDisabled, setbuttonDisabled] = useState(false)
    const [ curMode, setCurMode] = useState("")
    const [ selectedTournament, setSelectedTournament ] = useState(null)
    const [ tournamentData, setTournamentData ] = useState(null)
    const [ isLoading, setIsLoading ] = useState(false)

    const ShowPage = (setPage) => {
        if (setPage === -2)
            return <div>Скоро...</div>;
        if (setPage === -1)
            return <div></div>;
        if (setPage === 0)
            return SignInPage();
        if (setPage === 1) {
            if (!user.user) return SignInPage();
            if (!tournamentData) return <TournamentSelector onSelect={handleTournamentSelect} />;
            
            if (isLoading) {
                return (
                    <Container sx={styles.container}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                            <CircularProgress />
                        </Box>
                    </Container>
                );
            }
            
            // Для завершенных турниров сразу показываем результаты
            if (tournamentData.mode === "Results") {
                return ShowResultBoardPage();
            }
            return ChooseTeamsPage();
        }
        if (setPage === 2) {
            if (tournamentData.mode === "Wait for Results") {
                return ShowWaitForResultsPage();
            }
            return ShowChooseList();
        }
        if (setPage === 3)
            return ShowResultBoardPage();
    };

    const handleTournamentSelect = async (tournamentId) => {
        try {
            setIsLoading(true);
            const tournamentJson = require(`./MyComponents/TourJSON/${tournamentId}.json`);
            setTournamentData(tournamentJson);
            setCurMode(tournamentJson.mode);
            
            if (user.user) {
                if (tournamentJson.mode === "Results") {
                    const allData = await LoadData(tournamentJson);
                    setUsers(allData);
                    const userData = await getDoc(doc(db, tournamentJson.db, user.user.uid));
                    setUserData(userData.exists() ? userData.data().checkedList : []);
                    setCurPage(3);
                } else if (tournamentJson.mode === "Wait for Results") {
                    const allData = await LoadData(tournamentJson);
                    setUsers(allData);
                    const userData = await getDoc(doc(db, tournamentJson.db, user.user.uid));
                    setUserData(userData.exists() ? userData.data().checkedList : []);
                    setCurPage(2);
                } else if (tournamentJson.mode === "Vote") {
                    const userData = await getDoc(doc(db, tournamentJson.db, user.user.uid));
                    if (userData.exists()) {
                        setUserData(userData.data().checkedList);
                        const allData = await LoadData(tournamentJson);
                        setUsers(allData);
                        setCurPage(2);
                    } else {
                        setUserData([]);
                        setCurPage(1);
                    }
                }
            }
        } catch (error) {
            console.error('Ошибка загрузки турнира:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleBackToTournaments = () => {
        setTournamentData(null);
        setUserData([]);
        setUsers([]);
        setCurMode("");
        setSelectedTournament(null);
        setCurPage(1);
    };

    useEffect(() => {
        if (localStorage.getItem("userStorage"))
            LoadUser(JSON.parse(localStorage.getItem("userStorage")))
        else
            setCurPage(0)
    }, [])

    const LoadUser = async (log_user) => {
        setUser(log_user);
        setCurPage(1);
    };

    const SetVote = async (haveData) => {
        if (haveData)
            await LoadAnswerPage();
        else
            setCurPage(1);
    };

    const LoadAnswerPage = async () => {
        if (!tournamentData) return;
        if (tournamentData.mode === "Wait for Results") {
            setCurPage(2);
            return;
        }
        const allData = await LoadData(tournamentData);
        setUsers(allData);
        setCurPage(2);
    };

    const LoadCalculatedResults = async () => {
        if (!tournamentData) return;
        await LoadData();
        setCurPage(3);
    };

    const LoadData = async (currentTournament) => {
        const tournament = currentTournament || tournamentData;
        if (!tournament) return [];
        
        try {
            const docs = await getDocs(collection(db, tournament.db));
            const forPrint = [];
            
            docs.forEach(doc => {
                const data = doc.data();
                if (data.checkedList && Array.isArray(data.checkedList)) {
                    forPrint.push([data.name, data.checkedList, doc.id]);
                }
            });
            
            const processedData = forPrint.map(([name, checkedList, id]) => {
                const sum = checkedList.reduce((prev, cur) => {
                    if (typeof cur !== 'number' || !tournament.teams[cur]) {
                        return prev;
                    }
                    return prev + tournament.teams[cur].result;
                }, 0);
                return [name, checkedList, id, sum];
            });
            
            return processedData;
        } catch (error) {
            console.error('Ошибка загрузки данных:', error);
            return [];
        }
    };

    const SignInPage = () => {
        const logGoogleUser = async () => {
            setbuttonDisabled(true);
            try {
                const result = await signInWithGooglePopup();
                await LoadUser(result);
                localStorage.setItem("userStorage", JSON.stringify(result));
            } catch (error) {
                console.log(error);
            }
            setbuttonDisabled(false);
        };
        
        return (
            <Box sx={{ 
                height: '100vh', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                backgroundColor: 'background.default'
            }}>
                <Card sx={{ maxWidth: 400, width: '100%', p: 4 }}>
                    <CardContent sx={{ textAlign: 'center' }}>
                        <Typography variant="h4" gutterBottom>
                            Добро пожаловать
                        </Typography>
                        <Button
                            variant="contained"
                            startIcon={<GoogleIcon />}
                            onClick={logGoogleUser}
                            disabled={buttonDisabled}
                            sx={{ mt: 2 }}
                        >
                            {buttonDisabled ? (
                                <CircularProgress size={24} color="inherit" />
                            ) : (
                                'Войти через Google'
                            )}
                        </Button>
                    </CardContent>
                </Card>
            </Box>
        );
    };

    const logOut = () => {
        auth.signOut().then(function() {
            console.log('Signed Out');
            // Сбрасываем все состояния
            setUser([]);
            setUserData([]);
            setUsers([]);
            setCurMode("");
            setSelectedTournament(null);
            setTournamentData(null);
            setCurPage(0);
            localStorage.removeItem("userStorage");
        }, function(error) {
            console.error('Sign Out Error', error);
        });
    };

    const SaveDataAndGoToResults = async (checkedList) => {
        if (!tournamentData) return;
        try {
            await setDoc(doc(db, tournamentData.db, user.user.uid), {
                checkedList: checkedList,
                name: user.user.displayName,
                uid: user.user.uid
            });
            setUserData(checkedList);
            await LoadAnswerPage();
        } catch (e) {
            console.error("Error adding document: ", e);
        }
    };

    const Header = () => {
        if (!user.user) return null;
        return (
            <AppBar position="static" color="primary" elevation={0}>
                <Toolbar sx={styles.userInfo}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {tournamentData && (curMode !== "Vote" || curPage === 2) && (
                            <IconButton
                                color="inherit"
                                onClick={handleBackToTournaments}
                                sx={{ mr: 2 }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        )}
                        <Avatar 
                            src={user.user.photoURL} 
                            alt={user.user.displayName}
                            sx={{ mr: 2 }}
                        />
                        <Typography variant="h6">
                            {user.user.displayName}
                        </Typography>
                    </Box>
                    <Button
                        color="inherit"
                        onClick={logOut}
                        startIcon={<LogoutIcon />}
                    >
                        Выйти
                    </Button>
                </Toolbar>
            </AppBar>
        );
    };

    const ChooseTeamsPage = () => {
        if (!tournamentData) return null;
        return (
            <Container sx={styles.container}>
                <Table saveRes={SaveDataAndGoToResults} userData={userData} teams={tournamentData} onBack={handleBackToTournaments} />
            </Container>
        );
    };

    const ResultButtons = () => {
        if (!tournamentData) return null;

        const getUserPlace = () => {
            if (tournamentData.mode === "Vote") {
                return userData && userData.length > 0 ? "Ваш текущий выбор:" : "Вы пока не выбрали команды";
            }

            if (tournamentData.mode === "Wait for Results") {
                return userData && userData.length > 0 ? "Ваш выбор:" : "Вы не участвовали в этом турнире";
            }

            if (!userData || userData.length === 0) {
                return "Вы не участвовали в этом турнире";
            }

            const sortedUsers = [...users].sort((a, b) => b[3] - a[3]);
            const userIndex = sortedUsers.findIndex(u => u[2] === user.user.uid);
            
            if (userIndex === -1) return "Вы не участвовали в этом турнире";
            
            const place = userIndex + 1;
            const suffix = place % 10 === 1 && place !== 11 ? "ое" :
                          (place % 10 === 2 || place % 10 === 3 || place % 10 === 4) && 
                          (place < 10 || place > 20) ? "ье" : "ое";
            return `${place}-${suffix} место`;
        };

        const hasParticipated = tournamentData.mode === "Vote" || (userData && userData.length > 0 && users.some(u => u[2] === user.user.uid));

        return (
            <Box sx={{ mb: 4 }}>
                {tournamentData.mode === "Vote" && (
                    <Button 
                        variant="contained" 
                        color="secondary"
                        onClick={() => setCurPage(1)}
                        sx={{ mr: 2 }}
                    >
                        {userData && userData.length > 0 ? "Изменить выбор" : "Выбрать команды"}
                    </Button>
                )}
                <Typography variant="h5" sx={{ mt: 3, mb: 1 }}>
                    {getUserPlace()}
                </Typography>
                {hasParticipated && userData && userData.length > 0 && (
                    <>
                        {tournamentData.mode !== "Vote" && (
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                Ваш выбор:
                            </Typography>
                        )}
                        <Box sx={styles.resultItem}>
                            {userData
                                .sort((a, b) => tournamentData.teams[a].weight < tournamentData.teams[b].weight ? 1 : -1)
                                .map(team => (
                                    <Typography key={team} variant="body1" sx={{ py: 1 }}>
                                        {tournamentData.teams[team].name} - {tournamentData.mode === "Results" ? `${tournamentData.teams[team].result} (${tournamentData.teams[team].weight})` : tournamentData.teams[team].weight}
                                    </Typography>
                                ))}
                        </Box>
                    </>
                )}
            </Box>
        );
    };

    const ShowChooseList = () => {
        if (!tournamentData) return null;
        return (
            <Container sx={styles.container}>
                <ResultButtons />
                {users.map((user, index) => (
                    <Card key={user[2]} sx={styles.teamCard}>
                        <CardContent>
                            <Typography variant="h6">
                                {(index + 1)}. {user[0]}
                            </Typography>
                            <Box sx={{ mt: 2 }}>
                                {user[1]
                                    .sort((a, b) => tournamentData.teams[a].result < tournamentData.teams[b].result ? 1 : -1)
                                    .map(team => (
                                        <Typography key={team} variant="body2" sx={{ py: 0.5 }}>
                                            {tournamentData.teams[team].name} - {tournamentData.mode === "Results" ? `${tournamentData.teams[team].result} (${tournamentData.teams[team].weight})` : tournamentData.teams[team].weight}
                                        </Typography>
                                    ))}
                            </Box>
                        </CardContent>
                    </Card>
                ))}
            </Container>
        );
    };

    const ShowWaitForResultsPage = () => {
        if (!tournamentData) return null;
        return (
            <Container sx={styles.container}>
                <ResultButtons />
                {users.length > 0 ? (
                    users.map((u, index) => (
                        <Card key={u[2]} sx={styles.teamCard}>
                            <CardContent>
                                <Typography variant="h6">
                                    {(index + 1)}. {u[0]}
                                </Typography>
                                <Box sx={{ mt: 2 }}>
                                    {u[1]
                                        .sort((a, b) => tournamentData.teams[a].weight < tournamentData.teams[b].weight ? 1 : -1)
                                        .map(team => (
                                            <Typography key={team} variant="body2" sx={{ py: 0.5 }}>
                                                {tournamentData.teams[team].name} - {tournamentData.teams[team].weight}
                                            </Typography>
                                        ))}
                                </Box>
                            </CardContent>
                        </Card>
                    ))
                ) : (
                    <Typography variant="h6" color="text.secondary" sx={{ textAlign: 'center', my: 4 }}>
                        Нет участников
                    </Typography>
                )}
            </Container>
        );
    };

    const ShowResultBoardPage = () => {
        if (!tournamentData) return null;
        if (isLoading) {
            return (
                <Container sx={styles.container}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                        <CircularProgress />
                    </Box>
                </Container>
            );
        }
        return (
            <Container sx={styles.container}>
                <ResultButtons />
                {users.length > 0 ? (
                    users
                        .sort((a, b) => a[3] < b[3] ? 1 : -1)
                        .map((user, index) => (
                            <Card key={user[2]} sx={styles.teamCard}>
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        {(index + 1)}. {user[0]} - {user[3]}
                                    </Typography>
                                    <Box sx={{ mt: 2 }}>
                                        {user[1]
                                            .sort((a, b) => tournamentData.teams[a].result < tournamentData.teams[b].result ? 1 : -1)
                                            .map(team => (
                                                <Typography key={team} variant="body2" sx={{ py: 0.5 }}>
                                                    {tournamentData.teams[team].name} - {tournamentData.teams[team].result} ({tournamentData.teams[team].weight})
                                                </Typography>
                                            ))}
                                    </Box>
                                </CardContent>
                            </Card>
                        ))
                ) : (
                    <Typography variant="h6" color="text.secondary" sx={{ textAlign: 'center', my: 4 }}>
                        Нет данных о результатах
                    </Typography>
                )}
            </Container>
        );
    };

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ 
                minHeight: '100vh',
                backgroundColor: 'background.default'
            }}>
                <Header />
                {tournamentData && curPage === 3 && (
                    <Box sx={styles.header}>
                        <Typography variant="h3" component="h1">
                            {tournamentData.tour}
                        </Typography>
                    </Box>
                )}
                {ShowPage(curPage)}
            </Box>
        </ThemeProvider>
    );
}
export default App;